import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import rawBankTransactionsApi from '@/features/dashboard/rawBankTransactions/api/rawBankTransactionsApi.ts';
import { RawTransactionDto } from '@/features/dashboard/rawBankTransactions/types/RawTransactionDto.ts';
import { MatchToExpenseRequestDto } from '@/features/dashboard/rawBankTransactions/types/BankTransactionRequests.ts';
import { invalidateFinanceRelatedQueries } from '@/utils/invalidateFinanceQueries.ts';

const useMatchToExpense = () => {
  const queryClient = useQueryClient();

  return useMutation<
    RawTransactionDto,
    Error,
    { id: string; request: MatchToExpenseRequestDto }
  >({
    mutationFn: ({ id, request }) =>
      rawBankTransactionsApi.matchToExpense(id, request),
    onSuccess: () => {
      toast.success('Przelew został wpięty w wydatek');
      invalidateFinanceRelatedQueries(queryClient);
    },
    onError: (error: Error) => {
      toast.error('Nie udało się wpiąć przelewu w wydatek', {
        description: error.message,
      });
    },
  });
};

export default useMatchToExpense;
